import { Box, Card, Divider, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/system';
import { Layout } from 'components/layout';
import config from 'config';
import { Navigate } from 'react-router';
import { Link } from 'react-router-dom';
import Cookies from 'universal-cookie';
import Logo from 'assets/logos/hr-logo.png';
import EmployeeForgotPasswordRequestForm from '../components/EmployeeForgotPasswordRequestForm';

const EmployeeForgotPasswordRequest = () => {
    const theme = useTheme();
    const cookies = new Cookies();
    return cookies.get(config.cookieToken) ? (
        <Navigate to="/" />
    ) : (
        <Layout pageTitle="Login">
            <Box sx={{ backgroundColor: theme.palette.primary.light, minHeight: '100vh', p: 10 }}>
                <Grid container direction="column" justifyContent="flex-end" sx={{ minHeight: '100vh' }}>
                    <Grid item xs={12}>
                        <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 'calc(100vh - 68px)' }}>
                            <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
                                <Card sx={{ maxWidth: { xs: 400, lg: 475 }, p: { xs: 20, sm: 30, md: 30 } }}>
                                    <Grid container spacing={2} alignItems="center" justifyContent="center">
                                        <Grid item sx={{ mb: 20 }}>
                                            <Link to="#">
                                                <img src={Logo} alt="Logo" style={{ width: 200, height: 50 }} />
                                            </Link>
                                        </Grid>
                                        <Grid item xs={12} gap={6}>
                                            <Typography variant="h3" align="center" sx={{ mb: 6 }}>
                                                Forgot Password
                                            </Typography>
                                            <Typography variant="body1" align="center" sx={{ mb: 2 }}>
                                                Please enter your email address to receive a password reset link.
                                            </Typography>
                                            <EmployeeForgotPasswordRequestForm />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Divider />
                                        </Grid>
                                    </Grid>
                                </Card>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Layout>
    );
};

export default EmployeeForgotPasswordRequest;
